import { useContext } from 'react';
import { InventoryCompareProductsModalContext } from '../../InventoryCompareProductsModalContext';

export const useInventoryCompareProductsModalContext = () => {
    const context = useContext(InventoryCompareProductsModalContext);

    if (!context) {
        throw new Error(
            'useInventoryCompareProductsModalContext must be used within a InventoryCompareProductsModalContext'
        );
    }

    return context;
};
